import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialGlobalState";
import persistReducer from "redux-persist/es/persistReducer";
import storage from "redux-persist/lib/storage";

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setSelectedDriverId: (state, action) => {
      state.selectedDriverId = action.payload;
    },
    toggleDashboard: (state) => {
      state.isDashboardClicked = true;
      state.isDeliveriesClicked = false;
      state.isDriversClicked = false;
      state.isAddressesClicked = false;
      state.isIntegrationsClicked = false;
      state.isActiveSidebarBtn = "dashboard";
      state.selectedOrderIndex = 0;
    },
    toggleDeliveries: (state) => {
      state.isDashboardClicked = false;
      state.isDeliveriesClicked = true;
      state.isDriversClicked = false;
      state.isAddressesClicked = false;
      state.isIntegrationsClicked = false;
      state.isVehiclesClicked = false;
      state.isActiveSidebarBtn = "deliveries";
    },
    toggleDrivers: (state) => {
      state.isDashboardClicked = false;
      state.isDeliveriesClicked = false;
      state.isDriversClicked = true;
      state.isAddressesClicked = false;
      state.isIntegrationsClicked = false;
      state.isVehiclesClicked = false;
      state.isActiveSidebarBtn = "drivers";
    },
    toggleAddresses: (state) => {
      state.isDashboardClicked = false;
      state.isDeliveriesClicked = false;
      state.isDriversClicked = false;
      state.isAddressesClicked = true;
      state.isIntegrationsClicked = false;
      state.isVehiclesClicked = false;
      state.isActiveSidebarBtn = "addresses";
    },
    toggleIntegrations: (state) => {
      state.isDashboardClicked = false;
      state.isDeliveriesClicked = false;
      state.isDriversClicked = false;
      state.isAddressesClicked = false;
      state.isIntegrationsClicked = true;
      state.isVehiclesClicked = false;
      state.isActiveSidebarBtn = "integrations";
    },
    toggleVehicles: (state) => {
      state.isDashboardClicked = false;
      state.isDeliveriesClicked = false;
      state.isDriversClicked = false;
      state.isAddressesClicked = false;
      state.isIntegrationsClicked = false;
      state.isVehiclesClicked = true;
      state.isActiveSidebarBtn = "vehicles";
    },

    toggleThreeDotsModal: (state, action) => {
      state.modalPosition.x = action.payload.x;
      state.modalPosition.y = action.payload.y;
      state.showThreeDotsModal = !state.showThreeDotsModal;
    },

    setModalPosition: (state, action) => {
      state.modalPosition = action.payload;
    },

    setIsWithHistory: (state, action) => {
      state.isWithHistory = action.payload;
    },
    setIsDeleteModalShown: (state, action) => {
      state.isDeleteModalShown = action.payload;
    },
    setIsAddNewDriverShown: (state, action) => {
      state.isAddNewDriverShown = action.payload;
    },
    setIsDriverLocationShown: (state, action) => {
      state.isDriverLocationShown = action.payload;
    },
    setIsDriverInfoShown: (state, action) => {
      state.isDriverInfoShown = action.payload;
    },
    setIsDriverRoutes: (state, action) => {
      state.isDriverRoutes = action.payload;
    },
    setIsEditModalShown: (state) => {
      state.isEditModalShown = !state.isEditModalShown;
    },
    setIsDeleteConfirmShown: (state, action) => {
      state.isDeleteConfirmShown = action.payload;
    },
    setIsDeleteCustomerAddress: (state, action) => {
      state.isDeleteCustomerAddress = action.payload;
    },
    setIsAddNewCustomerAddress: (state, action) => {
      state.isAddNewCustomerAddress = action.payload;
    },
    setSelectedDataForEdit: (state, action) => {
      state.selectedDataForEdit = action.payload;
    },
    setIsCustomerActive: (state, action) => {
      state.isCustomerActive = action.payload;
    },
    setSelectedDelivery: (state, action) => {
      state.selectedDelivery = action.payload;
    },
    setIsAddLaundry: (state, action) => {
      state.isAddLaundry = action.payload;
    },
    setIsErrorMsg: (state, action) => {
      state.isErrorMsg = action.payload;
    },
    setErrorMsg: (state, action) => {
      state.errorMsg = action.payload;
    },
    setSuccessMsg: (state, action) => {
      state.successMsg = action.payload;
    },

    onEdit: (state) => {
      state.isModalsBgShown = !state.isModalsBgShown;
      state.isEditModalShown = !state.isEditModalShown;
      state.showThreeDotsModal = false;
    },
    setIsEditMode: (state, action) => {
      state.isEditMode = action.payload;
    },
    setShowThreeDotsModal: (state, action) => {
      state.showThreeDotsModal = action.payload;
    },
    onDelete: (state) => {
      state.isModalsBgShown = !state.isModalsBgShown;
      state.isDeleteModalShown = !state.isDeleteModalShown;
      state.showThreeDotsModal = false;
    },
    toggleAddNewDriverModal: (state) => {
      state.isModalsBgShown = !state.isModalsBgShown;
      state.isAddNewDriverShown = !state.isAddNewDriverShown;
      state.showThreeDotsModal = false;
    },
    toggleDriverInfoModal: (state) => {
      state.isModalsBgShown = !state.isModalsBgShown;
      state.isDriverInfoShown = !state.isDriverInfoShown;
      state.showThreeDotsModal = false;
    },
    onDeleteConfirm: (state) => {
      state.isModalsBgShown = true;
      state.isDeleteConfirmShown = true;
      state.isDeleteModalShown = false;
    },
    onErrorMessage: (state, action) => {
      state.isModalsBgShown = true;
      state.isErrorMsg = true;
    },
    setIsModalsBgShown: (state, action) => {
      state.isModalsBgShown = action.payload;
    },
    toggleDriverLocationModal: (state) => {
      state.isDriverLocationShown = !state.isDriverLocationShown;
      state.isModalsBgShown = !state.isModalsBgShown;
    },
    toggleAddLaundry: (state) => {
      state.isAddLaundry = !state.isAddLaundry;
      state.isModalsBgShown = state.isAddLaundry;
    },
    toggleAddNewCustomerAddress: (state) => {
      state.isAddNewCustomerAddress = !state.isAddNewCustomerAddress;
      state.isModalsBgShown = !state.isModalsBgShown;
    },
    toggleDeleteCustomerAddressModal: (state, action) => {
      state.isDeleteCustomerAddress = !state.isDeleteCustomerAddress;
      state.selectedDataForEdit = action.payload;
      state.isModalsBgShown = !state.isModalsBgShown;
    },
    setIsMapShown: (state, action) => {
      state.isMapShown = action.payload;
    },
    setAddressData: (state, action) => {
      state.addressData = action.payload;
    },
    setSelectedDriverInfo: (state, action) => {
      state.selectedDriverInfo = action.payload;
    },
    setIsDownloadAppShown: (state, action) => {
      state.isDownloadAppShown = action.payload;
    },
    setSelectedAddress: (state, action) => {
      state.selectedAddress = action.payload;
    },
    setIsFetchCurrentAddress: (state, action) => {
      state.isFetchCurrentAddress = action.payload;
    },
    setIsNewPickupAddressCreated: (state, action) => {
      state.isNewPickupAddressCreated = action.payload;
    },
    setIsNewCustomerCreated: (state, action) => {
      state.isNewCustomerCreated = action.payload;
    },
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
    setIsGenerateApiShown: (state, action) => {
      state.isModalsBgShown = action.payload;
      state.isGenerateApiShown = action.payload;
    },
    setIsApiKeyModalShown: (state, action) => {
      state.isModalsBgShown = action.payload;
      state.isApiKeyModalShown = action.payload;
    },
    setSelectedOrderIndex: (state, action) => {
      state.selectedOrderIndex = action.payload;
    },
    setDeliveriesToDisplay: (state, action) => {
      state.deliveriesToDisplay = action.payload;
    },
    setIsOrderInformationOpen: (state, action) => {
      state.isModalsBgShown = action.payload;
      state.isOrderInformationOpen = action.payload;
    },
    setSelectedPackage: (state, action) => {
      state.selectedPackage = action.payload;
    },
    closeAllModals: (state) => {
      state.isModalsBgShown = false;
      state.isDeleteModalShown = false;
      state.isAddNewDriverShown = false;
      state.isDriverLocationShown = false;
      state.isDriverInfoShown = false;
      state.isDriverRoutes = false;
      state.isEditModalShown = false;
      state.isDeleteConfirmShown = false;
      state.isDeleteCustomerAddress = false;
      state.isAddNewCustomerAddress = false;
      state.isAddLaundry = false;
      state.isErrorMsg = false;
      state.isMapShown = false;
      state.isDownloadAppShown = false;
      state.showThreeDotsModal = false;
      state.modalPosition = { x: 0, y: 0 };
      state.isGenerateApiShown = false;
      state.isApiKeyModalShown = false;
      state.isOrderInformationOpen = false;
    },
    setIsDriverLocationFromRoutes: (state, action) => {
      state.isDriverLocationFromRoutes = action.payload;
    },
    setSelectedDriverLocationIndex: (state, action) => {
      state.selectedDriverLocationIndex = action.payload;
    },
    setIsDeleteVehicleShown: (state, action) => {
      state.isModalsBgShown = action.payload;
      state.isDeleteVehicleShown = action.payload;
    },
    setShouldResetData: (state, action) => {
      state.shouldResetData = action.payload;
    },
    setShouldResetScheduledPackage: (state, action) => {
      state.shouldResetScheduledPackage = action.payload;
    },
  },
});

// Only persist these keys
const persistConfig = {
  key: "global",
  storage,
  whitelist: [
    // Pages
    "isDashboardClicked",
    "isDeliveriesClicked",
    "isDriversClicked",
    "isAddressesClicked",
    "isIntegrationsClicked",

    // Data
    "selectedDriverId",
    "selectedDelivery",
    "errorMsg",
    "successMsg",
    "addressData",
    "selectedDataForEdit",
    "selectedDriverInfo",
    "selectedAddress",
    "language",
    "selectedOrderIndex",
    "deliveriesToDisplay",

    // UI and State Flags
    "isActiveSidebarBtn",
    "isEditMode",
    "isWithHistory",
    "isCustomerActive",
    "isNewPickupAddressCreated",
    "isNewCustomerCreated",
  ],
};

export const {
  setIsNewCustomerCreated,
  setIsNewPickupAddressCreated,
  setIsFetchCurrentAddress,
  setSelectedAddress,
  setIsDownloadAppShown,
  setSelectedDriverInfo,
  setAddressData,
  setIsMapShown,
  toggleDeleteCustomerAddressModal,
  toggleAddNewCustomerAddress,
  toggleAddLaundry,
  toggleDriverLocationModal,
  setIsModalsBgShown,
  onDeleteConfirm,
  onErrorMessage,
  setSelectedDriverId,
  toggleDashboard,
  toggleDeliveries,
  toggleDrivers,
  toggleAddresses,
  toggleThreeDotsModal,
  setModalPosition,
  setIsWithHistory,
  setIsDeleteModalShown,
  setIsAddNewDriverShown,
  setIsDriverLocationShown,
  setIsDriverInfoShown,
  setIsDriverRoutes,
  setIsEditModalShown,
  setIsDeleteConfirmShown,
  setIsDeleteCustomerAddress,
  setIsAddNewCustomerAddress,
  setSelectedDataForEdit,
  setIsCustomerActive,
  setSelectedDelivery,
  setIsAddLaundry,
  setIsErrorMsg,
  setErrorMsg,
  setSuccessMsg,
  onEdit,
  setIsEditMode,
  setShowThreeDotsModal,
  onDelete,
  toggleAddNewDriverModal,
  toggleDriverInfoModal,
  setLanguage,
  toggleIntegrations,
  setIsGenerateApiShown,
  setIsApiKeyModalShown,
  setSelectedOrderIndex,
  setDeliveriesToDisplay,
  setIsOrderInformationOpen,
  setSelectedPackage,
  closeAllModals,
  setIsDriverLocationFromRoutes,
  setSelectedDriverLocationIndex,
  toggleVehicles,
  setIsDeleteVehicleShown,
  setShouldResetData,
  setShouldResetScheduledPackage,
} = globalSlice.actions;

export default persistReducer(persistConfig, globalSlice.reducer);
